import React, { useEffect, useRef, useState } from "react"
import "./mainframe.css"

const MainFrame = (props) => {
  const [isVisible, setIsVisible] = useState(props.isVisible)
  const containerRef = useRef(null)

  useEffect(() => {
    setIsVisible(props.isVisible)
  }, [props.isVisible])

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0
    }
  }, [props.children])

  const handleClose = () => {
    props.onClose()
    setIsVisible(false)
  }

  return (
    <div
      ref={containerRef}
      className={`mainframe-container ${
        isVisible ? "mainframe-visible" : "mainframe-hidden"
      }`}
    >
      {props.children}
    </div>
  )
}

export default MainFrame
